import React from 'react'
import { Card, CardContent, Grid2, Stack } from '@mui/material'
import i18n from 'simple-react-i18n'
import Select from 'components/forms/Select'
import SimpleTextArea from 'components/forms/SimpleTextArea'
import { shallowEqual, useSelector } from 'react-redux'
import useSandreList from 'utils/customHook/useSandreList'
import { SANDRE } from 'referencial/constants/ReferencialConstants'
import PropTypes from 'prop-types'

const PGSSEInfos = ({
    readMode,
    diagnostic = {},
    onChangeDiagnostic,
}) => {
    const {
        contributors,
        distributionUnits,
        sectors,
        surveys,
    } = useSelector(store => ({
        contributors: store.ContributorReducer.contributors,
        distributionUnits: store.DistributionUnitReducer.distributionUnits,
        sectors: store.SectorReducer.sectors,
        surveys: store.PgsseReducer.surveys,
    }), shallowEqual)

    const campaignStatus = useSandreList(SANDRE.CAMPAGNES_STATUT)

    return (
        <Card>
            <CardContent>
                <Grid2 container columnSpacing={1}>
                    <Grid2 size={6}>
                        <Stack container>
                            <Select
                                options={surveys}
                                label={i18n.pgsse}
                                value={diagnostic.idSurvey}
                                readMode
                                keyLabel='description'
                                keyValue='idSurvey'
                            />
                            <Select
                                options={contributors}
                                label={i18n.collectivity}
                                value={diagnostic.idContributor}
                                readMode
                            />
                            <Select
                                options={sectors}
                                label={i18n.sector}
                                value={diagnostic.idSector}
                                readMode
                            />
                            <Select
                                options={distributionUnits}
                                label={i18n.distributionUnitName}
                                value={diagnostic.idUdi}
                                keyValue='id'
                                readMode
                            />
                        </Stack>
                    </Grid2>
                    <Grid2 size={6}>
                        <Stack>
                            <Select
                                options={campaignStatus}
                                label={i18n.state}
                                value={diagnostic.status}
                                onChange={v => onChangeDiagnostic({ status: v })}
                                readMode={readMode}
                            />
                            <SimpleTextArea
                                title={i18n.comment}
                                value={diagnostic.comment}
                                onChange={v => onChangeDiagnostic({ comment: v })}
                                readMode={readMode}
                            />
                        </Stack>
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    )
}

PGSSEInfos.propTypes = {
    readMode: PropTypes.bool,
    diagnostic: PropTypes.object,
    onChangeDiagnostic: PropTypes.func,
}

export default PGSSEInfos